"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlicesTypes = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const CompositeSlice_1 = require("./CompositeSlice");
const SharedSlice_1 = require("./SharedSlice");
exports.SlicesTypes = t.keyof({
    [CompositeSlice_1.CompositeSliceType]: null,
    [SharedSlice_1.SharedSliceType]: null,
});
